export default (theme, colors) => ({
    root: {
        marginLeft: 'initial',
    },
    label: {
        color: colors.accentLight[0.75],
        fontSize: '1.2rem',
        '&$disabled': {
            color: colors.accentLight[0.25],
        },
    },
});
